import React, { useState, useEffect } from "react";

const Glimpse = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [
    "/Images/Glimpse/image1.png",
    "/Images/Glimpse/image2.jpg",
    "/Images/Glimpse/image3.png",
    "/Images/Glimpse/image4.png",
    "/Images/Glimpse/image5.png",
    "/Images/Glimpse/image6.png",
    "/Images/Glimpse/image7.png",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Auto-slide every 3 seconds
    return () => clearInterval(interval);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const handleClick = (index) => {
    setCurrentIndex(index);
  };

  const getPositionStyle = (index) => {
    const position = (index - currentIndex + images.length) % images.length;

    switch (position) {
      case 0: // Center image
        return {
          transform: "translateX(0) scale(1.2)",
          zIndex: 3,
          opacity: 1,
        };
      case 1: // Right side
        return {
          transform: "translateX(110%) scale(0.9)",
          zIndex: 2,
          opacity: 0.7,
        };
      case images.length - 1: // Left side
        return {
          transform: "translateX(-110%) scale(0.9)",
          zIndex: 2,
          opacity: 0.7,
        };
      default: // Hidden images
        return {
          transform: "translateX(200%) scale(0.7)",
          zIndex: 1,
          opacity: 0,
        };
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Glimpse</h1>
      <div style={styles.carouselWrapper}>
        <div style={styles.carousel}>
          {images.map((src, index) => (
            <div
              key={index}
              style={{
                ...styles.imageContainer,
                ...getPositionStyle(index),
                transition: "transform 0.6s ease, opacity 0.6s ease",
              }}
              onClick={() => handleClick(index)}
            >
              <img src={src} alt={`Slide ${index + 1}`} style={styles.image} />
            </div>
          ))}
        </div>
      </div>
      <div style={styles.controls}>
        <button style={styles.button} onClick={handlePrev}>
          ❮
        </button>
        <button style={styles.button} onClick={handleNext}>
          ❯
        </button>
      </div>
      <div style={styles.indicators}>
        {images.map((_, index) => (
          <span
            key={index}
            style={{
              ...styles.indicator,
              backgroundColor: index === currentIndex ? "#FF3E74" : "#ddd",
            }}
            onClick={() => handleClick(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    backgroundColor: "#fdfdfd",
    borderRadius: "16px",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
    width: "90%",
    maxWidth: "1000px",
    margin: "auto",
  },
  title: {
    fontSize: "36px",
    marginBottom: "20px",
    background: "linear-gradient(to right, #FF3E74, #FF9E3E)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  carouselWrapper: {
    overflow: "hidden",
    width: "100%",
    height: "375px",
    position: "relative",
    display: "flex",
    justifyContent: "center",
  },
  carousel: {
    display: "flex",
    position: "relative",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  imageContainer: {
    position: "absolute",
    top: "10%",
    bottom: "10%",
    transform: "translateY(-50%)",
    transition: "transform 0.6s ease, opacity 0.6s ease",
  },
  image: {
    width: "300px",
    height: "300px",
    objectFit: "cover",
    borderRadius: "10px",
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#FF3E74",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
  indicators: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginTop: "10px",
  },
  indicator: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
};

export default Glimpse;
